import { useEffect } from "react";
import { motion } from "framer-motion";
import math from "../img/discrete-math.png";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";
import TypeIt from "typeit";
import StudyingBoy from "../img/Studying.png";
import Professor from "../img/Professor-pana.png";
import CourseDetail2 from "../components/CoursesDetail2";
import CourseDetail21 from "../components/CourseDetail21";

const Discrete = () => {
  useEffect(() => {
    new TypeIt("#element", {
      strings: ["離散數學與演算法"],
      speed: 100,
      afterComplete: (instance) => {
        const el = document.querySelector("#element");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element2", {
      strings:
        "用 Python 或JavaScript  (二擇一) 來學習離散數學 - 電腦世界的數學語言 (邏輯、證明、遞迴關係、演算法、數論與密碼學、演算法分析、路徑選擇、資料結構、以及其他重要的程式開發演算法)",
      speed: 15,
      startDelay: 1500,
      loop: false,
      afterComplete: (instance) => {
        const el = document.querySelector("#element2");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();
  }, []);

  return (
    <div>
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        className="webdev"
        exit="exit"
      >
        <div className="img">
          <img src={math} alt="" />
        </div>
        <div className="desc">
          <h1>
            <span id="element"></span>
          </h1>
          <div className="notice">此課程為資料結構的前導課程！！</div>
          <div className="content">
            <h3 id="element2"></h3>
          </div>

          <div>
            <p>
              課程價格: <span className="hide">新台幣$540</span>
            </p>
            <p>
              優惠代碼(點擊連結即可自動套用優惠碼):
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/discrete-math-with-python-and-javascript/?couponCode=${process.env.REACT_APP_DISCRETE_MATH_COUPON}`}
              >
                <span>{process.env.REACT_APP_DISCRETE_MATH_COUPON}</span>
              </a>
              (只到
              <span style={{ color: "red" }}>{process.env.REACT_APP_DATE}</span>
              之前有效)
            </p>
            <p>
              課程連結:
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/discrete-math-with-python-and-javascript/?couponCode=${process.env.REACT_APP_DISCRETE_MATH_COUPON}`}
              >
                <span className="hide">
                  https://www.udemy.com/course/discrete-math-with-python-and-javascript/
                </span>
              </a>
            </p>
            {/* <p style={{ fontSize: "5px", opacity: "0.9" }} target="_blank">
              Hiskio 平台課程連結
              (無法使用優惠碼)：https://hiskio.com/courses/1196/about
            </p> */}
          </div>
        </div>
        <CourseDetail21 img={Professor} />
        <CourseDetail2 img={StudyingBoy} />
        <ScrollTop />
      </motion.div>
    </div>
  );
};

export default Discrete;
